function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo } from 'react';
import { default as ReviewInformation } from './ReviewInformation';
import { OverviewTemplate } from '../../../templates';
import { SectionTitle } from '../../SectionTitle';
export default /*#__PURE__*/memo(_ref => {
  let {
    heading,
    data,
    id,
    showRemove = false
  } = _ref;
  return /*#__PURE__*/React.createElement(OverviewTemplate, null, /*#__PURE__*/React.createElement(SectionTitle, _extends({}, heading, {
    id: `${id}`
  })), /*#__PURE__*/React.createElement(ReviewInformation, {
    data: data,
    id: id,
    showRemove: showRemove
  }));
});

//test commit
//# sourceMappingURL=Overview.js.map